/**
 * This is the master tag of the awin affiliation
 */
import React from 'react'
import Helmet from 'react-helmet'
import {useCustomPreference} from '../../hooks/use-custom-preference'

const AwinMasterTag = () => {
    const awinConfiguration = useCustomPreference('awinConfiguration')
    const {awinMerchantId} = awinConfiguration || ''
    return (
        <>
            {awinMerchantId && (
                <Helmet>
                    <script
                        src={`https://www.dwin1.com/${awinMerchantId}.js`}
                        type="text/javascript"
                        defer="defer"
                    ></script>
                </Helmet>
            )}
        </>
    )
}

export default AwinMasterTag
